import { handleResponse } from '../../Helpers/handle-response';
import * as apiHelper from '../../Helpers/apiHelper';


export function getByCarrier(id){
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        }
    };  
      
    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETBYCARRIER);
    url += `?carrierId=${id}`;
    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

export function getByCarrierBarcode(barcode){
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        }
    };  
      
    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETBYCARRIERBARCODE);
    url += `?barcode=${barcode}`;
    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

export function sendPauseWorkflow(workflowid) {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        },        
        // body: JSON.stringify({
        //     workflowId:workflowid
        // })
    };

    let url = apiHelper.ComposePickingUri(apiHelper.API_ACTION_SENDPAUSEWORKFLOW);
    url += `?workflowId=${workflowid}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

export function sendFinishWorkflow(workflowid) {
    const requestOptions = {
        method: 'PUT', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        },        
        // body: JSON.stringify({
        //     workflowId:workflowid
        // })
    };

    let url = apiHelper.ComposePickingUri(apiHelper.API_ACTION_SENDFINISHWORKFLOW);
    url += `?workflowId=${workflowid}`;
    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}


export function getPickStock(productBarcode,cartCode,quantity,workflowId ,materialType, workflowStepDetailId) {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        }
    };  
      
    let url = apiHelper.ComposePickingUri(apiHelper.API_ACTION_GETPICKSTOCK);
    url += `?productBarcode=${productBarcode}&cartCode=${cartCode}&quantity=${quantity}&workflowId=${workflowId}&materialType=${materialType}&workflowStepDetailId=${workflowStepDetailId}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}